import api from '@api/Api';

export default {

    getForm(id) {
        return api().get(`/forms/${id}`);
    },

    updateForm(id, params, step = null) {
        return api().put(`/forms/${id}`, { ...params, step: step });
    },

    updateFormName(id, name) {
        return api().put(`/forms/${id}/name`, { name: name });
    },

    duplicateForm(id) {
        return api().post(`/forms/${id}/duplicate`);
    },

    deleteForm(id) {
        return api().delete(`/forms/${id}`);
    },

    sortElements(id, params) {
        return api().put(`/forms/${id}/elements/sort`, params);
    },

    createElement(id, params) {
        return api().post(`/forms/${id}/elements/create`, params);
    },

    updateElement(id, elementId, params) {
        return api().put(`/forms/${id}/elements/${elementId}`, params);
    },

    deleteElement(id, elementId) {
        return api().delete(`/forms/${id}/elements/${elementId}`);
    },
}
